const { createContext } = require('react');

const CouponContext = createContext();
export default CouponContext;
